export enum SpaceType {
  NotDefined = 0,
  Owner = 1,
  Supplier = 2,
}
